<template>
  <div ref="html"></div>
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "RawHtml.vue",
  props: {
    cellProps: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$refs.html.innerHTML = DOMPurify.sanitize(this.cellProps, {ADD_TAGS: ['kenteken']});
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>